export const LIST_FILTERS = ['status', 'language', 'version', 'issue', 'type', 'refreshState'];

export const parseLanguageManagerQuery = search => {
  const params = new URLSearchParams(search || '');
  const result = {
    search: params.get('search') || '',
    page: Math.max(Number(params.get('page') || 0), 0),
    pageSize: Math.max(Number(params.get('pageSize') || 20), 1),
    sortBy: params.get('sortBy') || 'status',
    sortDir: params.get('sortDir') === 'desc' ? 'desc' : 'asc',
  };
  LIST_FILTERS.forEach(name => {
    result[name] = params.getAll(name);
  });
  return result;
};

export const serializeLanguageManagerQuery = query => {
  const params = new URLSearchParams();
  if (query.search) params.set('search', query.search);
  if (query.page) params.set('page', String(query.page));
  if (query.pageSize && query.pageSize !== 20) params.set('pageSize', String(query.pageSize));
  if (query.sortBy && query.sortBy !== 'status') params.set('sortBy', query.sortBy);
  if (query.sortDir && query.sortDir !== 'asc') params.set('sortDir', query.sortDir);
  LIST_FILTERS.forEach(name => {
    (query[name] || []).forEach(value => params.append(name, value));
  });
  const value = params.toString();
  return value ? `?${value}` : '';
};

export const apiParamsForQuery = query => ({
  search: query.search || undefined,
  page: query.page,
  pageSize: query.pageSize,
  sortBy: query.sortBy,
  sortDir: query.sortDir,
  status: query.status,
  language: query.language,
  version: query.version,
  issue: query.issue,
  type: query.type,
  refreshState: query.refreshState,
});

export const scopeForSelection = (selectedIds, query) =>
  selectedIds.length
    ? { trainingPartIds: selectedIds }
    : { filters: apiParamsForQuery({ ...query, page: 0, pageSize: 100 }) };

export const countSelectedSafeChanges = (selectedIds, rowsById) =>
  selectedIds.reduce((total, id) => total + ((rowsById[id] && rowsById[id].availableLanguages.length) || 0), 0);
